export const permissionsPartnersReadonly = [
  "partners-full",
  "partners-readonly",
  "everything-full",
  "everything-readonly",
];
